import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import ButtonIconPicker from 'client/components/core/Sidebar/components/Settings/components/ButtonIconPicker'
import { useUpdateFormSubentityProp } from '../../hooks/use-update-form-subentity-prop'
import {
  FormSubentityTypeEnum,
  FormInterface,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'
import { FormSubentityCommonSettingsButtonLink } from './form-subentity-common-settings-button-link'
import { SidebarBottomPortal } from 'src/editor/layout/sidebar/settings/sidebar-bottom-portal'

export interface FormSubmitButtonSubentitySettingsProps {
  formEntity: FormInterface
  submitButtonSubentity: FormSubmitButtonInterface
}

export const FormSubmitButtonSubentitySettings = ({
  formEntity,
  submitButtonSubentity,
}: FormSubmitButtonSubentitySettingsProps) => {
  const { t } = useTranslation()

  const updateProp = useUpdateFormSubentityProp(
    formEntity,
    submitButtonSubentity,
  )

  return (
    <>
      <TextInputControl
        wrapperProps={{
          labelText: t('entity_settings.button.button_text.label'),
        }}
        value={submitButtonSubentity.text}
        update={updateProp('text')}
      />
      <TextInputControl
        wrapperProps={{
          labelText: 'entity_settings.button.sub_text.label',
        }}
        update={updateProp('subText')}
        value={submitButtonSubentity.subText}
      />
      <ButtonIconPicker
        valueBefore={submitButtonSubentity.iconClassNameBefore}
        valueAfter={submitButtonSubentity.iconClassNameAfter}
        updateBefore={updateProp('iconClassNameBefore')}
        updateAfter={updateProp('iconClassNameAfter')}
      />
      <HtmlAttrId attrId={submitButtonSubentity.htmlAttrId} />

      <SidebarBottomPortal>
        <FormSubentityCommonSettingsButtonLink
          formEntity={formEntity}
          commonSettingsType={FormSubentityTypeEnum.SubmitButton}
        />
      </SidebarBottomPortal>
    </>
  )
}
